module.exports = __webpack_public_path__ + "static/media/chargesoftMarker.105f13ae.svg";